import { getCompanyInfo } from '../../utils/getCompanyInfo';
import SlsTracker from '@aliyun-sls/web-track-browser';

const opts = {
  host: 'cn-shenzhen.log.aliyuncs.com', // 所在地域的服务入口。例如cn-hangzhou.log.aliyuncs.com
  project: 'sls-cartsee-shenzhen', // Project名称。
  logstore: 'monitor-request', // Logstore名称。
  time: 10, // 发送日志的时间间隔，默认是10秒。
  count: 10, // 发送日志的数量大小，默认是10条。
  topic: 'cartsee', // 自定义日志主题。
  source: location.hostname,
  tags: {
    tags: 'martech_front'
  }
};

const tracker = new SlsTracker(opts);

export enum MonitorEvent {
  /**
   * 页面访问
   */
  PageView = 'pageView',

  /**
   * 环境变量
   */
  Environment = 'environment',

  /**
   * api请求
   */
  Request = 'request',

  /**
   * 点击
   */
  Click = 'click',

  /**
   * 功能维度
   */
  Function = 'function',

  /**
   * 异常错误
   */
  Error = 'error',

  /**
   * 需要注意
   */
  Warning = 'warning',

  /**
   * localStorage
   * 通过function getItem | setItem
   */
  LocalStorage = 'localStorage',

  /**
   * sessionStorage
   * 通过function区分 getItem | setItem
   */
  SessionStorage = 'sessionStorage'
}

export interface MonitorProps {
  /**
   * location.herf
   * 包含query
   */
  url: string;

  /**
   * location.pathname
   * 用于统计页面
   */
  pathname: string;

  /**
   * 公司id
   */
  companyId?: number;

  /**
   * 登录邮箱
   */
  user: string;

  /**
   * 登录token
   */
  token: string;

  /**
   * 事件类型
   */
  event: MonitorEvent;

  /**
   * 功能名称
   * 当 event=function 定义
   * @example Create（增）Read（查）Update（改）Delete（删）
   */
  function?: string;

  /**
   * 请求server地址，一般为影响存储的
   * 当 event=function 定义
   */
  requestUrl?: string;

  /**
   * 代码路径
   */
  file?: string;

  /**
   * 数据
   */
  data?: {
    [key: string]: any;
  };

  /**
   * 时间戳
   */
  dt: number;

  /**
   * 是否立即发送埋点，不使用延迟策略
   */
  immediate?: boolean;
}

export const monitor = (params?: Partial<MonitorProps>): void => {
  const { id } = getCompanyInfo();
  const { href, pathname } = window.location;
  const config: MonitorProps = {
    dt: new Date().getTime(),
    url: href,
    pathname,
    user: JSON.parse(localStorage.getItem('displayInfo') || '{}').email,
    token: localStorage.getItem('token') || '',
    companyId: id,
    event: MonitorEvent.PageView
  };

  const data = { ...config, ...params };

  if (process.env.NODE_ENV === 'production') {
    const { immediate, ...rest } = data
    if (immediate) {
      tracker.sendImmediate(rest);
    } else {
      tracker.send(rest);
    }
  } else {
    // 开发环境仅打印日志，不需要延迟处理
    if ([MonitorEvent.LocalStorage, MonitorEvent.SessionStorage].includes(data.event)) {
      console.log(`[monitor] ${data.event}${data.function ? `.${data.function}` : ''} ${data.data?.key}`, data);
    } else {
      console.log(`[monitor] ${data.event}`, data);
    }
  }
};
